var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "243.854pt",
    height: "467.159pt",
    viewBox: "1085.22 -1942.7 243.854 467.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xDD\\u0161\\u0164\\u015F 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 3",
    transform: "scale(1 -1)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0141\\u0161\\u0164\\u015F 3",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 12.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1203.03,1843.75 C 1205.49,1836.91 1212.22,1832.01 1220.13,1832.01 C 1230.1,1832.01 1238.23,1839.85 1238.23,1849.52 C 1238.23,1859.19 1230.1,1867.02 1220.13,1867.02",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1220.13,1867.02 C 1210.13,1867.02 1202.02,1874.86 1202.02,1884.53 C 1202.02,1894.2 1210.13,1902.03 1220.13,1902.03 C 1227.61,1902.03 1234.05,1897.63 1236.81,1891.34",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1220.13,1824.56 L 1220.13,1832.01",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1220.13,1902.04 L 1220.13,1909.62",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1294.53,1481.79 L 1119.78,1481.79 C 1104.15,1481.79 1091.47,1494.46 1091.47,1510.09 L 1091.47,1712.73 C 1091.47,1728.36 1104.15,1741.04 1119.78,1741.04 L 1294.53,1741.04 C 1310.16,1741.04 1322.83,1728.36 1322.83,1712.73 L 1322.83,1510.09 C 1322.83,1494.46 1310.16,1481.79 1294.53,1481.79 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1120.39,1741.04 L 1120.39,1771.79 L 1293.91,1771.79 L 1293.91,1741.04",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1253.86,1691.35 C 1313.12,1697.36 1318.75,1610.41 1210.61,1614.59",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1253.86,1691.35 C 1228.3,1745.15 1151.02,1704.92 1210.61,1614.59",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1137.66,1595.99 C 1145.06,1638.73 1207.14,1625.65 1183.03,1550.62",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1137.66,1595.99 C 1094.93,1588.6 1108.01,1526.52 1183.03,1550.62",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1266.28,1565.31 C 1313.59,1562.96 1307.63,1493.91 1223.09,1510.11",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1266.28,1565.31 C 1252.6,1610.67 1187.02,1588.27 1223.09,1510.11",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1273.84,1867.03 C 1273.84,1828.69 1250.6,1797.62 1221.93,1797.62 C 1193.26,1797.62 1170.02,1828.69 1170.02,1867.03 C 1170.02,1905.36 1193.26,1936.44 1221.93,1936.44 C 1250.6,1936.44 1273.84,1905.36 1273.84,1867.03 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1192.35,1797.63 C 1163.69,1797.63 1140.46,1828.71 1140.46,1867.01 C 1140.46,1905.36 1163.69,1936.45 1192.35,1936.45",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1192.38,1936.44 L 1221.93,1936.44",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1221.93,1797.62 L 1192.38,1797.62",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar);
export default __webpack_public_path__ + "static/media/jar.5ae2a80a24568c10490211022c8c0606.svg";
export { ForwardRef as ReactComponent };